import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';
import { hash } from 'rsvp';

import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class IndexRoute extends Route {
  @service announcements;
  @service keywords;
  @service uiPages;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: 'RISE is an open data system for viewing, accessing, and '
            + 'downloading data and reports on water, reservoir operations, water '
            + 'quality, hydropower, endangered and invasive species, and more from '
            + 'the Bureau of Reclamation. With RISE you can find Reclamation data '
            + 'by searching the catalog or browsing the map, query time series data '
            + 'for specific dates, parameters, and locations, then plot or download '
            + 'the data, obtain machine-readable data through an Application '
            + 'Programming Interface (API) for integration into tools and analyses, '
            + 'view geospatial data on a map, download it for offline analysis, '
            + 'or get a web service connection to add to your own map.',
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(
            true,
            this.keywords.strings['data-keywords'],
            this.keywords.strings['about-keywords'],
          ),
        },
      },
    ];
  }

  model() {
    return hash({
      home: this.uiPages.get('home'),
      announcements: this.announcements.fetch('home-announcements'),
    });
  }
}
